<section class="cargo-shell">
  <header class="cargo-hero">
    <div>
      <h2 class="cargo-title">{{ isEditMode ? 'Editar Cargo' : 'Novo Cargo' }}</h2>
      <p class="cargo-subtitle">Preencha os dados do cargo.</p>
    </div>
    <span class="cargo-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="cargoForm" (ngSubmit)="salvar()" id="cargoForm" class="cargo-card">
    <div class="form-section">
      <h3>Dados do Cargo</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="descricao" class="form-label">Descrição *</label>
          <input
            type="text"
            class="form-control"
            id="descricao"
            formControlName="descricao"
            [class.is-invalid]="descricao?.invalid && descricao?.touched"
          />
          <div class="invalid-feedback" *ngIf="descricao?.invalid && descricao?.touched">
            Descrição é obrigatória.
          </div>
        </div>

        <div class="col-md-6">
          <label for="nivel" class="form-label">Nível *</label>
          <select
            class="form-control"
            id="nivel"
            formControlName="nivel"
            [class.is-invalid]="nivel?.invalid && nivel?.touched"
          >
            <option value="">Selecione um nível</option>
            <option *ngFor="let n of niveis" [value]="n.descricao">
              {{ n.descricao }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="nivel?.invalid && nivel?.touched">
            Nível é obrigatório.
          </div>
        </div>

        <div class="col-md-6">
          <label for="salarioBase" class="form-label">Salário Base *</label>
          <input
            type="number"
            class="form-control"
            id="salarioBase"
            formControlName="salarioBase"
            min="0"
            step="0.01"
            [class.is-invalid]="salarioBase?.invalid && salarioBase?.touched"
          />
          <div class="invalid-feedback" *ngIf="salarioBase?.invalid && salarioBase?.touched">
            Salário base deve ser maior ou igual a 0.
          </div>
        </div>

        <div class="col-md-6">
          <label for="valeAlimentacao" class="form-label">Vale Alimentação *</label>
          <input
            type="number"
            class="form-control"
            id="valeAlimentacao"
            formControlName="valeAlimentacao"
            min="0"
            step="0.01"
            [class.is-invalid]="valeAlimentacao?.invalid && valeAlimentacao?.touched"
          />
          <div class="invalid-feedback" *ngIf="valeAlimentacao?.invalid && valeAlimentacao?.touched">
            Vale alimentação deve ser maior ou igual a 0.
          </div>
        </div>

        <div class="col-md-6">
          <label for="valeRefeicao" class="form-label">Vale Refeição *</label>
          <input
            type="number"
            class="form-control"
            id="valeRefeicao"
            formControlName="valeRefeicao"
            min="0"
            step="0.01"
            [class.is-invalid]="valeRefeicao?.invalid && valeRefeicao?.touched"
          />
          <div class="invalid-feedback" *ngIf="valeRefeicao?.invalid && valeRefeicao?.touched">
            Vale refeição deve ser maior ou igual a 0.
          </div>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="cargoForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>
